import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Modal, Select } from 'redpoints-front-components/index';

import { testPurchaseFetchDiscardedReasons } from '../../../actions/testPurchaseActions';
import {
  getTestPurchaseDiscardedReasons,
  getTestPurchaseDiscardedReasonsHasError,
  getTestPurchaseDiscardedReasonsIsLoading,
} from '../../../reducers/tasks/testPurchase';
import { translate } from '../../../helpers/languageHelper';

const TestPurchaseDiscardedReasonsModal = ({
  hasError,
  isLoading,
  onAccept,
  onCancel,
  reasons,
  testPurchaseFetchDiscardedReasons,
}) => {
  const [selectedReason, setSelectedReason] = useState({});

  useEffect(() => {
    if (!isLoading && !reasons && !hasError) {
      testPurchaseFetchDiscardedReasons();
    }
  }, [isLoading, testPurchaseFetchDiscardedReasons, reasons, hasError]);

  const handleAccept = useCallback(() => {
    if (selectedReason) {
      onAccept(selectedReason);
    }
  }, [onAccept, selectedReason]);

  const handleReasonChange = useCallback(
    reasonId => {
      const selectedReason = reasons.find(
        reason => reason.testPurchaseDiscardedReasonId === reasonId
      );
      setSelectedReason(selectedReason);
    },
    [reasons]
  );

  return (
    <Modal
      cancelText={translate('actions.cancel')}
      okText={translate('actions.confirm')}
      onOk={handleAccept}
      okButtonProps={{
        disabled: isLoading || !selectedReason.testPurchaseDiscardedReasonId,
      }}
      visible={true}
      title={translate('tasks.testPurchase.modals.discarded.title')}
      onCancel={onCancel}
    >
      <Select
        aria-label="discarded-reasons-select"
        data={reasons ?? []}
        disabled={isLoading || !reasons}
        mapping={{ key: 'testPurchaseDiscardedReasonId', value: 'name' }}
        onChange={handleReasonChange}
        value={selectedReason.name}
        placeholder="Reason"
      />
    </Modal>
  );
};

const mapStateToProps = state => ({
  hasError: getTestPurchaseDiscardedReasonsHasError(state),
  isLoading: getTestPurchaseDiscardedReasonsIsLoading(state),
  reasons: getTestPurchaseDiscardedReasons(state),
});

export default connect(mapStateToProps, {
  testPurchaseFetchDiscardedReasons,
})(TestPurchaseDiscardedReasonsModal);
